var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "pt-2" },
    [
      _vm.message.sender_type === "user"
        ? _c(
            "div",
            [
              _vm.message.type === "text"
                ? [_c("text-message", { attrs: { message: _vm.message } })]
                : _vm._e(),
              _vm._v(" "),
              _vm.message.type === "image"
                ? [_c("image-message", { attrs: { message: _vm.message } })]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ],
            2
          )
        : _c(
            "div",
            [
              _c("img", {
                staticClass: "float-left align-items-center chat-profile",
                attrs: { src: "/static/img/logo-chat-booking.png" }
              }),
              _vm._v(" "),
              _vm.message.type === "text"
                ? [_c("text-message", { attrs: { message: _vm.message } })]
                : _vm._e(),
              _vm._v(" "),
              _vm.message.type === "image"
                ? [_c("image-message", { attrs: { message: _vm.message } })]
                : _vm.message.type === "template"
                ? [_c("template-message", { attrs: { message: _vm.message } })]
                : _vm.message.type === "register"
                ? [_c("register-message", { attrs: { message: _vm.message } })]
                : _vm.message.type === "otp"
                ? [_c("otp-message", { attrs: { message: _vm.message } })]
                : _vm.message.type === "create-user-place"
                ? [
                    _c("user-place-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "select-date-time"
                ? [_c("date-time-message", { attrs: { message: _vm.message } })]
                : _vm.message.type === "buttons"
                ? [_c("buttons-message", { attrs: { message: _vm.message } })]
                : _vm.message.type === "booking-summary" ||
                  _vm.message.type === "booking-summary-incomplete"
                ? [
                    _c("booking-summary-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "payment-method"
                ? [
                    _c("payment-method-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "bank-transfer"
                ? [
                    _c("bank-transfer-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "change-payment-bank-transfer"
                ? [
                    _c("change-payment-bank-transfer-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "promptpay"
                ? [_c("promptpay-message", { attrs: { message: _vm.message } })]
                : _vm.message.type === "credit-card"
                ? [
                    _c("credit-card-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "order-detail"
                ? [
                    _c("order-detail-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "service-request-detail"
                ? [
                    _c("service-request-detail-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "additional-remark"
                ? [
                    _c("additional-remark-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "create-service-request-first"
                ? [
                    _c("service-request-first-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "create-service-request-second"
                ? [
                    _c("service-request-second-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "service-items"
                ? [
                    _c("service-item-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm.message.type === "has-ironing-board"
                ? [
                    _c("has-ironing-board-message", {
                      attrs: { message: _vm.message }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ],
            2
          ),
      _vm._v(" "),
      _c("quick-reply", { attrs: { message: _vm.message } }),
      _vm._v(" "),
      _c("carousel", { attrs: { message: _vm.message } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a1d7759", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a1d7759","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/Message.vue
// module id = 2262
// module chunks = 0